/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { FeeTokenPoolDispatcherL1 } from "./FeeTokenPoolDispatcherL1";

export class FeeTokenPoolDispatcherL1Factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<FeeTokenPoolDispatcherL1> {
    return super.deploy(overrides || {}) as Promise<FeeTokenPoolDispatcherL1>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): FeeTokenPoolDispatcherL1 {
    return super.attach(address) as FeeTokenPoolDispatcherL1;
  }
  connect(signer: Signer): FeeTokenPoolDispatcherL1Factory {
    return super.connect(signer) as FeeTokenPoolDispatcherL1Factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FeeTokenPoolDispatcherL1 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as FeeTokenPoolDispatcherL1;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "feeRewardPool",
        type: "address",
      },
    ],
    name: "FeeRewardPoolAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "feeRewardPool",
        type: "address",
      },
    ],
    name: "FeeRewardPoolRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "feeRewardPool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "FeeTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "TOKEN_AMOUNT_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IRewardRecipient",
        name: "_recipient",
        type: "address",
      },
    ],
    name: "addFeeRewardPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    name: "feeRewardPoolMap",
    outputs: [
      {
        internalType: "contract IRewardRecipient",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "feeTokens",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getFeeTokenLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
    ],
    name: "isFeeTokenExisted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IRewardRecipient",
        name: "_recipient",
        type: "address",
      },
    ],
    name: "removeFeeRewardPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "transferToFeeRewardPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b50611ac0806100206000396000f3fe608060405234801561001057600080fd5b50600436106100ea5760003560e01c806382fbcc261161008c5780639dd0cf71116100665780639dd0cf711461019b578063bc5920ba146101ae578063de114190146101b6578063ebef27be146101cb576100ea565b806382fbcc26146101785780638da5cb5b146101805780638ef4403c14610188576100ea565b80636c8381f8116100c85780636c8381f814610140578063715018a61461014857806378098ccf146101505780638129fc1c14610170576100ea565b806313af4035146100ef5780631a4d096114610104578063257767591461012d575b600080fd5b6101026100fd3660046114a7565b6101d3565b005b6101176101123660046114a7565b6102b5565b604051610124919061154b565b60405180910390f35b61010261013b3660046114a7565b6102d0565b61011761050b565b61010261051a565b61016361015e3660046114a7565b610599565b60405161012491906115b6565b610102610610565b61010261069b565b610117610722565b6101176101963660046114ff565b610731565b6101026101a93660046114a7565b610758565b6101026108c0565b6101be610983565b6040516101249190611a40565b6101be610988565b6101db61098e565b6065546001600160a01b039081169116146102115760405162461bcd60e51b815260040161020890611949565b60405180910390fd5b6001600160a01b0381166102375760405162461bcd60e51b8152600401610208906117a9565b6065546001600160a01b03828116911614156102655760405162461bcd60e51b8152600401610208906119f0565b6066546001600160a01b03828116911614156102935760405162461bcd60e51b815260040161020890611662565b606680546001600160a01b0319166001600160a01b0392909216919091179055565b60cc602052600090815260409020546001600160a01b031681565b6102d861098e565b6065546001600160a01b039081169116146103055760405162461bcd60e51b815260040161020890611949565b6001600160a01b03811661032b5760405162461bcd60e51b815260040161020890611891565b6000816001600160a01b031663fc0c546a6040518163ffffffff1660e01b8152600401602060405180830381600087803b15801561036857600080fd5b505af115801561037c573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906103a091906114e3565b905060006103b560cd8363ffffffff61099216565b90506001600160a01b0381166103dd5760405162461bcd60e51b815260040161020890611996565b816001600160a01b0316816001600160a01b03161461040e5760405162461bcd60e51b8152600401610208906119c4565b6040516370a0823160e01b81526000906001600160a01b038416906370a082319061043d90309060040161154b565b60206040518083038186803b15801561045557600080fd5b505afa158015610469573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061048d9190611517565b111561049e5761049c82610aa0565b505b6001600160a01b03808316600090815260cc60205260409081902080546001600160a01b0319811690915590519116907fa551baddb3e03710917b6b140b0b4d5d3b003376d62a588a25744a3cc8370fea906104fd908590849061155f565b60405180910390a150505050565b6066546001600160a01b031690565b61052261098e565b6065546001600160a01b0390811691161461054f5760405162461bcd60e51b815260040161020890611949565b6065546040516000916001600160a01b0316907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908390a3606580546001600160a01b0319169055565b60006106088260cd8054806020026020016040519081016040528092919081815260200182805480156105f557602002820191906000526020600020905b81546001600160a01b031681526001909101906020018083116105d7575b5050505050610ba290919063ffffffff16565b90505b919050565b600054610100900460ff16806106295750610629610bf8565b80610637575060005460ff16155b6106535760405162461bcd60e51b8152600401610208906117eb565b600054610100900460ff1615801561067e576000805460ff1961ff0019909116610100171660011790555b610686610bfe565b8015610698576000805461ff00191690555b50565b60cd546106ba5760405162461bcd60e51b815260040161020890611839565b6000805b60cd54811015610704576106f260cd82815481106106d857fe5b6000918252602090912001546001600160a01b0316610aa0565b806106fa5750815b91506001016106be565b50806106985760405162461bcd60e51b815260040161020890611868565b6065546001600160a01b031690565b60cd818154811061073e57fe5b6000918252602090912001546001600160a01b0316905081565b61076061098e565b6065546001600160a01b0390811691161461078d5760405162461bcd60e51b815260040161020890611949565b60cd546014116107af5760405162461bcd60e51b815260040161020890611772565b6000816001600160a01b031663fc0c546a6040518163ffffffff1660e01b8152600401602060405180830381600087803b1580156107ec57600080fd5b505af1158015610800573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061082491906114e3565b905061083760cd8263ffffffff610c7c16565b6108535760405162461bcd60e51b815260040161020890611891565b6001600160a01b03818116600090815260cc60205260409081902080546001600160a01b03191692851692909217909155517fe75de6f5bb42c9fd77881e126dc670147ee72bcf0fdf8b62cd4c317441f59df7906108b4908390859061155f565b60405180910390a15050565b6066546001600160a01b03166108e85760405162461bcd60e51b8152600401610208906118fa565b6108f061098e565b6066546001600160a01b0390811691161461091d5760405162461bcd60e51b8152600401610208906116a9565b6066546065546040516001600160a01b0392831692909116907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a360668054606580546001600160a01b03199081166001600160a01b03841617909155169055565b601481565b60cd5490565b3390565b60006001600160a01b0382166109aa57506000610a9a565b825460005b81811015610a93578481815481106109c357fe5b6000918252602090912001546001600160a01b0385811691161415610a8b57600182038114610a54578460018303815481106109fb57fe5b9060005260206000200160009054906101000a90046001600160a01b0316858281548110610a2557fe5b9060005260206000200160006101000a8154816001600160a01b0302191690836001600160a01b031602179055505b84805480610a5e57fe5b600082815260209020810160001990810180546001600160a01b031916905501905550829150610a9a9050565b6001016109af565b5060009150505b92915050565b6000610aaa611494565b610ab48330610d35565b9050610abf81610dc9565b15610b99576001600160a01b03808416600090815260cc602052604090205416610aea848284610dcd565b604051600162a6079360e01b031981526001600160a01b0382169063ff59f86d90610b19908590600401611a36565b600060405180830381600087803b158015610b3357600080fd5b505af1158015610b47573d6000803e3d6000fd5b505050507f1d6298f49fc15449b78df91fcca6812136edc2972366cb70aa0d9145a308cd318482610b7785610dc9565b604051610b8693929190611579565b60405180910390a160019250505061060b565b50600092915050565b6000805b8351811015610bee57838181518110610bbb57fe5b60200260200101516001600160a01b0316836001600160a01b03161415610be6576001915050610a9a565b600101610ba6565b5060009392505050565b303b1590565b600054610100900460ff1680610c175750610c17610bf8565b80610c25575060005460ff16155b610c415760405162461bcd60e51b8152600401610208906117eb565b600054610100900460ff16158015610c6c576000805460ff1961ff0019909116610100171660011790555b610c74610efc565b610686610f7d565b60006001600160a01b0382161580610cf25750610cf283805480602002602001604051908101604052809291908181526020018280548015610ce757602002820191906000526020600020905b81546001600160a01b03168152600190910190602001808311610cc9575b505050505083610ba2565b15610cff57506000610a9a565b50815460018082018455600093845260209093200180546001600160a01b0319166001600160a01b039290921691909117905590565b610d3d611494565b610dc283846001600160a01b03166370a08231856040518263ffffffff1660e01b8152600401610d6d919061154b565b60206040518083038186803b158015610d8557600080fd5b505afa158015610d99573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610dbd9190611517565b611057565b9392505050565b5190565b610dd6836110e9565b610dde611494565b610de88484610d35565b90506000610df68584611136565b905060006060866001600160a01b031663a9059cbb60e01b8785604051602401610e2192919061159d565b60408051601f198184030181529181526020820180516001600160e01b03166001600160e01b0319909416939093179092529051610e5f919061152f565b6000604051808303816000865af19150503d8060008114610e9c576040519150601f19603f3d011682016040523d82523d6000602084013e610ea1565b606091505b5091509150818015610ecb575080511580610ecb575080806020019051810190610ecb91906114c3565b610ee75760405162461bcd60e51b8152600401610208906115f4565b610ef3878785876111b4565b50505050505050565b600054610100900460ff1680610f155750610f15610bf8565b80610f23575060005460ff16155b610f3f5760405162461bcd60e51b8152600401610208906117eb565b600054610100900460ff16158015610686576000805460ff1961ff0019909116610100171660011790558015610698576000805461ff001916905550565b600054610100900460ff1680610f965750610f96610bf8565b80610fa4575060005460ff16155b610fc05760405162461bcd60e51b8152600401610208906117eb565b600054610100900460ff16158015610feb576000805460ff1961ff0019909116610100171660011790555b6000610ff561098e565b606580546001600160a01b0319166001600160a01b038316908117909155604051919250906000907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908290a3508015610698576000805461ff001916905550565b61105f611494565b600061106a8461120d565b9050601281106110af576040805160208101909152806110a461109484601263ffffffff6112fa16565b8690600a0a63ffffffff61133c16565b815250915050610a9a565b6040805160208101909152806110df6110cf60128563ffffffff6112fa16565b8690600a0a63ffffffff61137e16565b9052949350505050565b60006110f48261120d565b6001600160a01b0383166000908152609960205260409020549091508114611132576001600160a01b03821660009081526099602052604090208190555b5050565b6000806111428461120d565b9050601281106111805761117861116082601263ffffffff6112fa16565b600a0a61116c85610dc9565b9063ffffffff61137e16565b915050610a9a565b6111ac61119460128363ffffffff6112fa16565b600a0a6111a085610dc9565b9063ffffffff61133c16565b949350505050565b6111e76111d16111c48685611057565b839063ffffffff6113b816565b6111db8686610d35565b9063ffffffff6113e416565b60000b156112075760405162461bcd60e51b8152600401610208906118b8565b50505050565b6001600160a01b038116600090815260996020526040812054806106085760408051600481526024810182526020810180516001600160e01b031663313ce56760e01b17905290516000916060916001600160a01b0387169161126f9161152f565b600060405180830381855afa9150503d80600081146112aa576040519150601f19603f3d011682016040523d82523d6000602084013e6112af565b606091505b50915091508180156112c15750805115155b6112dd5760405162461bcd60e51b8152600401610208906116f0565b808060200190518101906112f19190611517565b95945050505050565b6000610dc283836040518060400160405280601e81526020017f536166654d6174683a207375627472616374696f6e206f766572666c6f77000081525061140c565b6000610dc283836040518060400160405280601a81526020017f536166654d6174683a206469766973696f6e206279207a65726f000000000000815250611438565b60008261138d57506000610a9a565b8282028284828161139a57fe5b0414610dc25760405162461bcd60e51b815260040161020890611731565b6113c0611494565b6113c8611494565b825184516113db9163ffffffff61146f16565b81529392505050565b8051825160009110156113f957506001610a9a565b815183511015610b995750600019610a9a565b600081848411156114305760405162461bcd60e51b815260040161020891906115c1565b505050900390565b600081836114595760405162461bcd60e51b815260040161020891906115c1565b50600083858161146557fe5b0495945050505050565b600082820183811015610dc25760405162461bcd60e51b81526004016102089061162b565b6040518060200160405280600081525090565b6000602082840312156114b8578081fd5b8135610dc281611a75565b6000602082840312156114d4578081fd5b81518015158114610dc2578182fd5b6000602082840312156114f4578081fd5b8151610dc281611a75565b600060208284031215611510578081fd5b5035919050565b600060208284031215611528578081fd5b5051919050565b60008251611541818460208701611a49565b9190910192915050565b6001600160a01b0391909116815260200190565b6001600160a01b0392831681529116602082015260400190565b6001600160a01b039384168152919092166020820152604081019190915260600190565b6001600160a01b03929092168252602082015260400190565b901515815260200190565b60006020825282518060208401526115e0816040850160208701611a49565b601f01601f19169190910160400192915050565b6020808252601d908201527f446563696d616c45524332303a207472616e73666572206661696c6564000000604082015260600190565b6020808252601b908201527f536166654d6174683a206164646974696f6e206f766572666c6f770000000000604082015260600190565b60208082526027908201527f5065727046694f776e61626c65557067726164653a2073616d652061732063616040820152666e64696461746560c81b606082015260800190565b60208082526027908201527f5065727046694f776e61626c65557067726164653a206e6f7420746865206e656040820152663b9037bbb732b960c91b606082015260800190565b60208082526021908201527f446563696d616c45524332303a2067657420646563696d616c73206661696c656040820152601960fa1b606082015260800190565b60208082526021908201527f536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f6040820152607760f81b606082015260800190565b60208082526019908201527f65786365656420746f6b656e20616d6f756e74206c696d697400000000000000604082015260600190565b60208082526022908201527f5065727046694f776e61626c65557067726164653a207a65726f206164647265604082015261737360f01b606082015260800190565b6020808252602e908201527f436f6e747261637420696e7374616e63652068617320616c726561647920626560408201526d195b881a5b9a5d1a585b1a5e995960921b606082015260800190565b602080825260159082015274199959551bdad95b9cc81b9bdd081cd95d081e595d605a1b604082015260600190565b6020808252600f908201526e666565206973206e6f77207a65726f60881b604082015260600190565b6020808252600d908201526c1a5b9d985b1a59081a5b9c1d5d609a1b604082015260600190565b60208082526022908201527f446563696d616c45524332303a2062616c616e636520696e636f6e73697374656040820152611b9d60f21b606082015260800190565b6020808252602f908201527f5065727046694f776e61626c65557067726164653a2063616e6469646174652060408201526e6973207a65726f206164647265737360881b606082015260800190565b6020808252602d908201527f5065727046694f776e61626c65557067726164653a2063616c6c65722069732060408201526c3737ba103a34329037bbb732b960991b606082015260800190565b6020808252601490820152731d1bdad95b88191bd95cc81b9bdd08195e1a5cdd60621b604082015260600190565b6020808252601290820152713932b6b7bb32903bb937b733903a37b5b2b760711b604082015260600190565b60208082526026908201527f5065727046694f776e61626c65557067726164653a2073616d65206173206f726040820152651a59da5b985b60d21b606082015260800190565b9051815260200190565b90815260200190565b60005b83811015611a64578181015183820152602001611a4c565b838111156112075750506000910152565b6001600160a01b038116811461069857600080fdfea26469706673582212201764788adfabd64b95589ac09e196dee9fdb099f8ddb2ce0a1c0eea5182ee44064736f6c63430006090033";
